module.exports = __webpack_public_path__ + "static/media/MP-SPEC-LQ104V1LG81.5a8a24c0.pdf";